import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NexusNav from "@/components/nexus/NexusNav";
import { NexusAuthProvider } from "@/context/NexusAuthContext";
import { Link } from "react-router-dom";

export default function NexusLayout() {
  const { t } = useTranslation();
  return (
    <NexusAuthProvider>
      <div className="nx-shell">
        <NexusNav />
        <main>
          <Outlet />
        </main>
        <footer className="border-t border-white/8 mt-24">
          <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-12 grid gap-8 md:grid-cols-4 text-white/75">
            <div>
              <div className="font-serif text-lg text-white mb-2">Corpora Nexus</div>
              <p className="text-sm text-white/60">{t("nexus.home.heroLead")}</p>
            </div>
            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#C9896E] mb-3">{t("nexus.nav.marketplace")}</div>
              <ul className="space-y-2 text-sm">
                <li><Link to="/nexus/listings" className="hover:text-white">{t("nexus.listing.allListings")}</Link></li>
                <li><Link to="/nexus/sell" className="hover:text-white">{t("nexus.home.listYourAsset")}</Link></li>
                <li><Link to="/nexus/buy-side-request" className="hover:text-white">{t("nexus.nav.buySide")}</Link></li>
              </ul>
            </div>
            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#C9896E] mb-3">{t("nexus.nav.buySide")}</div>
              <ul className="space-y-2 text-sm">
                <li><Link to="/nexus/register" className="hover:text-white">{t("nexus.nav.qualifyAsBuyer")}</Link></li>
                <li><Link to="/nexus/signin" className="hover:text-white">{t("nexus.nav.signIn")}</Link></li>
                <li><Link to="/nexus/account" className="hover:text-white">{t("nexus.nav.account")}</Link></li>
              </ul>
            </div>
            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#C9896E] mb-3">Corpora Consultants</div>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="hover:text-white">Firm home</Link></li>
                <li><Link to="/services" className="hover:text-white">Advisory & Due Diligence</Link></li>
                <li><Link to="/contact" className="hover:text-white">Speak with counsel</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-white/8">
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-8 text-white/60">
              <p className="text-xs leading-relaxed max-w-4xl" data-testid="nexus-master-disclaimer">
                {t("nexus.home.masterDisclaimer")}
              </p>
              <div className="mt-6 pt-6 border-t border-white/6 flex flex-wrap items-center justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.24em] text-white/40">
                <div>© {new Date().getFullYear()} Corpora Consultants Ltd</div>
                <div>Limassol · Cyprus · <Link to="/" className="underline hover:text-white">corporaco.com →</Link></div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </NexusAuthProvider>
  );
}
